import { useEffect } from "react";
import { useAppSelector } from "../../../Store";
import { ValueType } from "../../../Definitions";
import { UndefinedOptions } from "./useSelectOptions";
import { gql, useQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { selectAllLocationOptions, selectAllSectionOptions, upsertLocationOptions, upsertSectionOptions } from "../../../Store/OptionsHandlers/optionsCombinedReducer";
import { BasicQueryInfoInput } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedComponentsCall";


const SECTION_LOCATION_OPTIONS_QUERY = gql`
  query SectionLocationOptions($domain: String!, $input: BasicQueryInfoInput!) {
    section {
      info(domain: $domain, input: $input) {
        label: name
        id: section_id
        systemId: system_id
        panel_section_type
        locations: section_locations {
          id: location_id
          label: name
        }
      }
    }
  }
`

interface SectionWithLocationsOptions extends ValueType {
  systemId: number,
  locations: ValueType[]
}

interface SectionLocationOptionsResponse {
  section: {
    info: SectionWithLocationsOptions[];
  }
}

export const useSectionOptions = (includeUndefinedOption?: UndefinedOptions, systemId?: number, sectionId?: number,) => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";

  const fetchTime = useAppSelector(({optionsState}) => {if ("lastFetched" in optionsState.sectionOptions && typeof optionsState.sectionOptions.lastFetched === "number") {return optionsState.sectionOptions.lastFetched}})
  const dispatch = useDispatch();
  const reduxSectionOptions = useAppSelector(selectAllSectionOptions);
  const reduxLocationOptions = useAppSelector(selectAllLocationOptions);

  const {data: sectionsLocations, loading} = useQuery<SectionLocationOptionsResponse, {domain: string, input: BasicQueryInfoInput}>(SECTION_LOCATION_OPTIONS_QUERY, {
    skip: !!reduxSectionOptions.length || fetchTime !== undefined || (fetchTime && (Date.now()-fetchTime > 300000)),
    fetchPolicy: "no-cache",
    variables: {
      domain: farm,
      input: {fetchAmount: 500}
    },
  })


  useEffect(() => {
    if (!loading && sectionsLocations && !reduxSectionOptions.length) {
      const {sectionOptions, locationOptions} = sectionsLocations.section.info.reduce((agg, sectionWithLocations) => {
        const {locations, ...section} = sectionWithLocations;
        agg.sectionOptions.push(section);
        agg.locationOptions.push(...locations.map((location) => ({...location, systemId: section.systemId, sectionId: section.id})))
        return agg;
      },  {sectionOptions: [], locationOptions: []} as {sectionOptions: (ValueType & {systemId: number})[], locationOptions: (ValueType & {sectionId: number, systemId: number})[]})
      dispatch(upsertSectionOptions(sectionOptions));
      dispatch(upsertLocationOptions(locationOptions))
    }
  },[dispatch, loading, reduxSectionOptions.length, sectionsLocations])


  if (includeUndefinedOption === UndefinedOptions.nan) {
    return {allSectionOptions: reduxSectionOptions, locationOptions: [{ label: "no location", id: NaN }, ...reduxLocationOptions]};
  }
  if (includeUndefinedOption === UndefinedOptions.undefined) {
    return {allSectionOptions: reduxSectionOptions, locationOptions: [{ label: "no location", id: null }, ...reduxLocationOptions] as ValueType[]};
  }
  return {allSectionOptions: reduxSectionOptions, locationOptions: reduxLocationOptions};
};
